import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd';

export type BlockItem = {
  className: 'base' | 'best' | 'neutral' | 'worst';
  titleKey: string;
  descriptionKey: string;
  disclaimerKey?: string;
};

@Component({
  selector: 'app-projection-chart-calculation-modal',
  templateUrl: './projection-chart-calculation.modal.html',
  styleUrls: ['./projection-chart-calculation.modal.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectionChartCalculationModal implements OnInit {
  public blocks: BlockItem[];

  constructor(private readonly _nzModalRef: NzModalRef) {}

  public ngOnInit(): void {
    this.blocks = [
      {
        className: 'base',
        titleKey: 'modals.projection-chart-calculation.base.title',
        descriptionKey: 'modals.projection-chart-calculation.base.description',
        disclaimerKey: 'modals.projection-chart-calculation.scenarios.disclaimer'
      },
      {
        className: 'best',
        titleKey: 'modals.projection-chart-calculation.best.title',
        descriptionKey: 'modals.projection-chart-calculation.best.description'
      },
      {
        className: 'neutral',
        titleKey: 'modals.projection-chart-calculation.neutral.title',
        descriptionKey: 'modals.projection-chart-calculation.neutral.description'
      },
      {
        className: 'worst',
        titleKey: 'modals.projection-chart-calculation.worst.title',
        descriptionKey: 'modals.projection-chart-calculation.worst.description'
      }
    ];
  }

  public onButtonClicked(): void {
    this._nzModalRef.close();
  }
}
